import { useLocation } from 'react-router-dom'

import getInitialState from 'Common/utils/getInitialState'
import getTags from '../getTags'
import CollectionAndSublistTagsAlert from './CollectionAndSublistTagsAlert'

export default function CollectionAndSublistTags() {
  const { pathname } = useLocation()
  const { tag: collectionTag, slugMap } = getInitialState()
  return (
    <CollectionAndSublistTagsAlert
      tags={getTags({ collectionTag, pathname, slugMap }).join(', ')}
    />
  )
}
